import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import departmentalBudgetService from '../../../services/departmentalBudgetService';

const SpendingTrendChart = ({ trends }) => {
  if (!trends || trends?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-6 text-center">
        <p className="text-muted-foreground">No spending trend data available</p>
      </div>
    );
  }

  const chartData = trends?.map(trend => ({
    month: new Date(trend?.trendMonth)?.toLocaleDateString('en-US', { month: 'short', year: 'numeric' }),
    spent: trend?.monthlySpentKina,
    cumulative: trend?.cumulativeSpentKina,
    utilization: trend?.budgetUtilizationPercentage
  }));

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-medium text-foreground mb-2">{payload?.[0]?.payload?.month}</p>
          <div className="space-y-1">
            <p className="text-xs text-muted-foreground">
              Monthly Spent: <span className="font-medium text-foreground">{departmentalBudgetService?.formatKina(payload?.[0]?.value)}</span>
            </p>
            <p className="text-xs text-muted-foreground">
              Cumulative: <span className="font-medium text-foreground">{departmentalBudgetService?.formatKina(payload?.[1]?.value)}</span>
            </p>
            <p className="text-xs text-muted-foreground">
              Utilization: <span className="font-medium text-foreground">{payload?.[2]?.value?.toFixed(2)}%</span>
            </p>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-heading font-semibold text-foreground mb-4">Spending Trends</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis 
            dataKey="month" 
            stroke="var(--color-muted-foreground)" 
            style={{ fontSize: '12px' }}
          />
          <YAxis 
            stroke="var(--color-muted-foreground)" 
            style={{ fontSize: '12px' }}
            tickFormatter={(value) => `K ${(value / 1000)?.toFixed(0)}k`}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend 
            wrapperStyle={{ fontSize: '12px' }}
            iconType="line"
          />
          <Line 
            type="monotone" 
            dataKey="spent" 
            stroke="var(--color-primary)" 
            strokeWidth={2}
            name="Monthly Spent"
            dot={{ fill: 'var(--color-primary)', r: 4 }}
          />
          <Line 
            type="monotone" 
            dataKey="cumulative" 
            stroke="var(--color-success)" 
            strokeWidth={2}
            name="Cumulative"
            dot={{ fill: 'var(--color-success)', r: 4 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SpendingTrendChart;